// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
//

export const LABEL_SELECT_ALL = 'Select All';
export const LABEL_CLEAR_ALL = 'Unselect All';